module.exports = __webpack_public_path__ + "static/assets/bf3ee9d7d91a231cde773f88f6799425.png";